import m from "./../../../dist/es2015/locales/sv_SE.js";
export const am5locales_sv_SE = m;